import { render } from "./NumberGrouping.vue?vue&type=template&id=4b8e78cc&scoped=true"
import script from "./NumberGrouping.vue?vue&type=script&lang=js"
export * from "./NumberGrouping.vue?vue&type=script&lang=js"

import "./NumberGrouping.vue?vue&type=style&index=0&id=4b8e78cc&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8e78cc"]])

export default __exports__